import { render, staticRenderFns } from "./VariantTitle.vue?vue&type=template&id=55c6f731&scoped=true"
import script from "./VariantTitle.vue?vue&type=script&lang=js"
export * from "./VariantTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c6f731",
  null
  
)

export default component.exports